export const homepageButtonOptions = [
  { key: "auto", label: "Auto" },
  { key: "auto_home", label: "Auto + Home" },
  { key: "home", label: "Home" },
  { key: "auto_renters", label: "Auto + Renters" },
  { key: "renters", label: "Renters" },
  { key: "life", label: "Life" },
  { key: "commercial", label: "Commercial" },
  { key: "additional_services", label: "Additional Services" },
] as const;

export type HomepageButtons = Partial<
  Record<(typeof homepageButtonOptions)[number]["key"], boolean>
>;

export function resolveHomepageButtons(
  settings?: HomepageButtons | null,
): HomepageButtons {
  return Object.fromEntries(
    homepageButtonOptions.map(({ key }) => [key, settings?.[key] !== false]),
  );
}
